let prefix = '/api/sap/credit-note';

function getCreditNote() {
    return window.axios.get(prefix+'/getCreditNote')
}
export default {
    getCreditNote
}